import { apiGetTeamAppListBy_tpl, ITeamAppListBy_tplParams, RespApp } from '@vas2t-lowcode/api';
import type { AxiosPromise } from 'axios';

let teamAppListByTplReq = undefined as undefined | AxiosPromise<RespApp[]>;

/**
 * 获取预加载的数据
 *
 * @returns
 */
export const reqTeamAppListByTplAsync = (params: ITeamAppListBy_tplParams) => {
  if (!teamAppListByTplReq) {
    teamAppListByTplReq = apiGetTeamAppListBy_tpl(params);
    return teamAppListByTplReq;
  }

  return teamAppListByTplReq;
};

/**
 * 重置预加载的数据, 防止下次 reqTeamAppListByTplAsync 获取的为旧数据
 *
 * @returns
 */
export const resetTeamAppListByTplAsync = () => {
  teamAppListByTplReq = undefined;
};
